import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useEffect } from "react";
import { Skeleton } from "@mui/material";
import useDatosNegocio from "./Context/useDatosNegocio";
const DatosGenerales = () => {
  const { datosNegocio, obtenerDatosNegocio, peticionDatosNegocio } = useDatosNegocio();
  const formatearTelefono = (numero = false) => {
    if (!numero) {
      return "Sin teléfono";
    }
    const numeroLimpio = numero.replace(/\D/g, "");
    const formato = `(${numeroLimpio.slice(0, 3)}) ${numeroLimpio.slice(
      3,
      6
    )}-${numeroLimpio.slice(6, 10)}`;
    return formato;
  };
  useEffect(() => {
    obtenerDatosNegocio();
  }, []);
  if (peticionDatosNegocio.cargando) {
    return <Skeleton style={{height:"100px"}} />;
    }
  return (
    <div className="datos-personales">
      <div className="informacion">
        <h2>{datosNegocio.Nombre} </h2>
        <h3>({datosNegocio.NombreComercial})</h3>
        <div className="direccion">
          <h3>
            {datosNegocio.Calle} {datosNegocio.NumeroExterior}
          </h3>
          <h4>
            {datosNegocio.Colonia}, {datosNegocio.Municipio} C.P.
            {datosNegocio.CodigoPostal}
          </h4>
 
        </div>
      </div>
      <div className="contacto">
        <div className="campo">
          <FontAwesomeIcon className="icono" icon={faEnvelope} />
          <p>{datosNegocio.CorreoElectronico}</p>
        </div>
        <div className="campo">
          <FontAwesomeIcon className="icono" icon={faWhatsapp} />
          <p>
            {datosNegocio.Telefono === ""
              ? "Sin teléfono"
              : datosNegocio.Telefono}
          </p>
        </div>
        <div className="campo">
          <FontAwesomeIcon className="icono" icon={faPhone} />
          <p>{formatearTelefono(datosNegocio.Celular)}</p>
        </div>
      </div>
    </div>
  );
};

export default DatosGenerales;
